export function getApiUrl(): string {
  const { hostname } = window.location;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const base = isLocalhost ? 'http://localhost:5000' : 'https://fintitles.com';
  return `${base}/api`;
}